export default __webpack_public_path__ + "static/media/fbc170fb385770bd385b14cbbc981275.jpg";